module.exports = __webpack_public_path__ + "icon-128-visualisation-bubble.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-bubble.png
// module id = 627
// module chunks = 11